import { useEffect, useRef, useState } from "react";
import { Share2, Link as LinkIcon, Facebook, MessageCircle, Check } from "lucide-react";
import { toast } from "sonner";
import { STORE, formatGs } from "../data/store";

export const productShareUrl = (product) => `${process.env.REACT_APP_BACKEND_URL}/api/share/${encodeURIComponent(product.code)}`;
export const productPageUrl = (product) => `/producto/${encodeURIComponent(product.code)}`;

export const ShareButton = ({ product }) => {
  const [open, setOpen] = useState(false);
  const [copied, setCopied] = useState(false);
  const ref = useRef(null);

  const url = productShareUrl(product);
  const text = `${product.name} — ${formatGs(product.price)} en ${STORE.name} (${STORE.slogan}).\n${url}`;

  useEffect(() => {
    if (!open) return;
    const onDoc = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, [open]);

  const share = async () => {
    if (navigator.share) {
      try { await navigator.share({ title: product.name, text, url }); return; } catch { /* cancelled */ }
    }
    setOpen((o) => !o);
  };

  const copy = async () => {
    try { await navigator.clipboard.writeText(url); setCopied(true); toast.success("Enlace copiado"); setTimeout(() => setCopied(false), 1500); }
    catch { toast.error("No se pudo copiar"); }
    setOpen(false);
  };

  return (
    <div ref={ref} className="relative">
      <button
        data-testid={`share-${product.code}`} onClick={share} title="Compartir"
        className="inline-flex items-center justify-center w-11 h-11 rounded-full border border-gray-300 text-gray-600 hover:border-[#0A3977] hover:text-[#0A3977] transition-colors"
      >
        <Share2 className="w-4 h-4" />
      </button>
      {open && (
        <div data-testid={`share-menu-${product.code}`} className="absolute bottom-full right-0 mb-2 w-52 bg-white rounded-xl shadow-2xl border border-gray-200 p-1.5 z-20">
          <a data-testid={`share-wa-${product.code}`} href={`https://wa.me/?text=${encodeURIComponent(text)}`} target="_blank" rel="noreferrer" onClick={() => setOpen(false)}
            className="flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-semibold hover:bg-gray-50">
            <MessageCircle className="w-4 h-4 text-[#25D366]" /> WhatsApp
          </a>
          <a data-testid={`share-fb-${product.code}`} href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`} target="_blank" rel="noreferrer" onClick={() => setOpen(false)}
            className="flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-semibold hover:bg-gray-50">
            <Facebook className="w-4 h-4 text-[#1877F2]" /> Facebook
          </a>
          <button data-testid={`share-copy-${product.code}`} onClick={copy}
            className="w-full flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-semibold hover:bg-gray-50 text-left">
            {copied ? <Check className="w-4 h-4 text-green-600" /> : <LinkIcon className="w-4 h-4 text-gray-500" />} Copiar enlace
          </button>
        </div>
      )}
    </div>
  );
};
